import Vue from 'vue';
import Vuex from 'vuex';
import authModule from './auth';
import resvModule from './resv';

// 愛爾麗
import airleeAuthModule from './airlee/auth';
import airleeClinicModule from './airlee/clinic';
import airleeResvModule from './airlee/resv';
import mgmModule from './mgm';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    token: '',
    function_list: '',
    // user: JSON.parse(localStorage.getItem('resv_user')),
    message: '',
  },
  actions: {
    setLoading(context, status) {
      context.commit('LOADING', status, { root: true });
    },
  },
  mutations: {
    LOADING(state, status) {
      state.isLoading = status;
    },
    TOKEN(state, status) {
      const { data, clinicCode } = status;
      localStorage.setItem(`token_${clinicCode}`, data);
      state.token = data;
    },
    // 愛爾麗
    AIRLEE_TOKEN(state, status) {
      localStorage.setItem(`token`, status);
    },
    AIRLEE_STAFF(state, status) {
      localStorage.setItem(`airlee_staff`, JSON.stringify(status));
    }
    // USER(state, status) {
    //   state.user = status;
    // },
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    tokenByC: () => (clinicCode) => {
      const token = localStorage.getItem(`token_${clinicCode}`);
      if (token) {
        return token;
      } else {
        return '';
      }
    },
    // 愛爾麗
    airleeToken() {
      return localStorage.getItem(`token`);
    },
    airleeStaff() {
      return JSON.parse(localStorage.getItem(`airlee_staff`));
    },
    // user(state) {
    //   return state.user;
    // },
  },
  modules: {
    authModule,
    resvModule,
    airleeAuthModule,
    airleeClinicModule,
    airleeResvModule,
    mgmModule,
  },
});
